import React from 'react';
import { Section } from './Shared';
import { offer } from '../data/offer';
import { testimonials } from '../data/landing';

/** Only rendered when the testimonials are confirmed authentic for this edition. */
export const Testimonials = () => {
  if (!offer.testimonialsVerified) return null;
  return <Section className="max-w-5xl" data-id="element-208" data-mp="3b1ckbbpjr2jo">
      <h2 className="text-[28px] md:text-5xl font-display font-bold leading-tight text-brand-purpleDark text-center" data-id="element-209" data-mp="3b01el6cjjkpx">
        💬 Experiencias compartidas por terapeutas
      </h2>
      <div className="mt-10 grid md:grid-cols-3 gap-5" data-id="element-210" data-mp="31z3ayp60lf7v">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-2xl bg-white/85 border border-brand-purple/15 p-6" data-id="element-211" data-mp="2x1uowdhqwr1c">
            <blockquote className="text-base text-brand-text leading-relaxed flex-grow" data-id="element-212" data-mp="2s42wzjh3p4x5">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3" data-id="element-213" data-mp="qa3mv1fpstm1">
              <span className="w-10 h-10 rounded-full bg-brand-purpleDark text-brand-goldLight font-serif font-bold flex items-center justify-center text-sm" data-id="element-214" data-mp="h5y7wcgvp92k">
                {t.initials}
              </span>
              <span data-id="element-215" data-mp="780ktsar9ibj">
                <span className="block font-semibold text-brand-purpleDark" data-id="element-216" data-mp="78jzn053zqlc">
                  {t.name}
                </span>
                <span className="block text-sm text-brand-muted" data-id="element-217" data-mp="c7dfgz7vbtoo">
                  {t.location}
                </span>
              </span>
            </figcaption>
          </figure>)}
      </div>
    </Section>;
};